import { call, put, select } from "redux-saga/effects";
import { addItemRequest, getItemsRequest, updateItemRequest } from "../../spItems/api";
import { VPORequirementsConditionsListName, VPOStatusQuestionnaireListName } from "src/api/config";
import { setStatusQuestionarySuccess } from "../actions";
import { getDefaultSaga } from "./getDefaultSaga";
import { updateDefaultSaga } from "src/modules/spItems/sagas/updateDefaultSaga";
import { addDefaultSaga } from "src/modules/spItems/sagas/addDefaultSaga";
import { ContentTypeIdGroupRequirement, ContentTypeIdRequirement } from "../api/config";
import { getSaga } from "./itemsWatcher";
import moment from "moment";

export function* setStatusQuestionarySaga({ payload }: any) {
  try {
    if (payload) {

      const { 
        Title,
        ColumnID,
        ColumnTitle,
        GroupID,
        GroupTitle,
        FactoryID,
        FactoryTitle,
        Status,
        Month,
        Year,
        Subdivisions,
        SubdivisionID,
        SubdivisionTitle
      } = payload;

      let isStatusID = false;
      let currentStatusQuestionary = null;
      let count_questionaries = 0;
      let count_yes = 0;
      let count_null = 0;
      let count_no = 0;

      const response: unknown = yield call<any>(getDefaultSaga, {
        listName: VPOStatusQuestionnaireListName,
        filtersType: 'and',
        filters: {
          ColumnID: '' + ColumnID,
          GroupID: '' + GroupID,
          FactoryID: '' + FactoryID,
          Month: '' + Month,
          Year: '' + Year
        },
      });

      console.log('response-status', response);

      if(
        response &&
        response.items &&
        response.items.length > 0
      ){
        isStatusID = response.items[0].ID;
        if(
          response.items[0].Status &&
          response.items[0].Status.get_lookupId
        ){
          currentStatusQuestionary = response.items[0].Status.get_lookupId();
        } 
        // count_questionaries = response.items[0].CountQuestions;
      }

      let response_conditions: unknown = yield call<any>(getDefaultSaga, {
        listName: VPORequirementsConditionsListName,
        filters: {
          GroupRequirementFileRef: '*' + ColumnID + '_.000/' + GroupID + '_.000',
          FactoryID: '' + FactoryID,
          Month: '' + Month,
          Year: '' + Year
        },
      });

      let response_group_requirements: unknown = yield call<any>(getDefaultSaga, {
        listName: 'VPOColumns',
        recursiveAll: true,
        contentType: 'Requirement',
        filtersType: 'and',
        filters: {
          ContentTypeId: '^' + ContentTypeIdGroupRequirement,
          FileRef: '*' + ColumnID + '_.000/' + GroupID + '_.000',
        }
      })

      if(
        response_conditions &&
        response_conditions.items &&
        response_conditions.items.length > 0
      ){
        response_conditions.items.map((item: any) => {
          if(item.Condition.get_lookupId() === 1){
            count_yes = count_yes + 1;
          }
          if(item.Condition.get_lookupId() === 2){
            count_no = count_no + 1;
          }
          if(item.Condition.get_lookupId() === 3){
            count_null = count_null + 1;
          }
        })
      }

      // let default_conditions: unknown = yield call<any>(getDefaultSaga, {
      //   listName: 'VPODefaultRequirementConditions',
      //   recursiveAll: true,
      //   filtersType: 'and',
      //   filters: {
      //     FileRef: '*' + ColumnTitle + '/' + GroupTitle + '/',
      //     Condition: 'Lock',
      //   },
      // })

      // if(
      //   default_conditions &&
      //   default_conditions.items &&
      //   default_conditions.items.length > 0
      // ){
      //   count_null = count_null + default_conditions.items.length;
      // }

      // if(
      //   response_conditions &&
      //   response_conditions.items &&
      //   response_conditions.items.length > 0
      // ){

      //   count_no = count_no + (count_questionaries - response_conditions.items.length);

      //   count_null = count_questionaries - count_yes - count_no + count_null;

      // }

      let response_requirements: unknown = yield call<any>(getDefaultSaga, {
        listName: 'VPOColumns',
        recursiveAll: true,
        contentType: 'Requirement',
        filtersType: 'and',
        filters: {
          ContentTypeId: '^' + ContentTypeIdRequirement,
          FileRef: '*' + ColumnID + '_.000/' + GroupID + '_.000',
          // FinishDate: {
          //   start: moment(),
          //   end: moment()
          // },
          // StartDate1: {
          //   start: moment(),
          //   end: moment()
          // }
        }
      })

      console.log('response_group_requirements', response_group_requirements, response_requirements);

      if(
        response_requirements &&
        response_requirements.items &&
        response_requirements.items.length > 0
      ){

        let count_requirements = response_requirements.items.filter(item => {

          let active_group = true;

          if(
            response_group_requirements &&
            response_group_requirements.items &&
            response_group_requirements.items.length > 0
          ){
            let filter_group = response_group_requirements.items.filter(group => item.FileRef.indexOf('/'+group.ID+'/') >= 0);

            if(
              filter_group &&
              filter_group.length > 0
            ){
              if(
                (
                  filter_group[0].FinishDate && 
                  filter_group[0].FinishDate !== '' && 
                  moment(filter_group[0].FinishDate) < moment() 
                ) || ( 
                  filter_group[0].StartDate1 && 
                  filter_group[0].StartDate1 !== '' && 
                  moment(filter_group[0].StartDate1) > moment() 
                ) 
              ){
                active_group = false;
              }
            }
          }

          return ( 
            active_group &&
            item.FinishDate && 
            item.FinishDate !== '' && 
            moment(item.FinishDate) > moment() 
          ) || ( 
            active_group &&
            item.StartDate1 && 
            item.StartDate1 !== '' && 
            moment(item.StartDate1) < moment() 
          ) 
        });

        count_questionaries = count_requirements.length * Subdivisions.length;

        let count_no_default = count_questionaries - count_no - count_yes - count_null;

        count_no = count_no + count_no_default;
        
      }
      
      // if(
      //   response_requirements &&
      //   response_requirements.items &&
      //   response_requirements.items.length > 0
      // ){

      //   let count_requirements = response_requirements.items.filter(item => {
      //     return ( item.FinishDate && item.FinishDate !== '' && moment(item.FinishDate) > moment() ) ||
      //       ( item.StartDate1 && item.StartDate1 !== '' && moment(item.StartDate1) < moment() ) 
      //   });

      //   console.log('response_requirements', count_requirements);

      //   count_questionaries = count_requirements.length * Subdivisions.length;
      // }

      if(!isStatusID){

        yield call<any>(addDefaultSaga, {
          listName: VPOStatusQuestionnaireListName,
          body: {
            Title,
            Status: 1,
            ColumnID,
            ColumnTitle,
            GroupID,
            GroupTitle,
            FactoryID,
            FactoryTitle,
            Month,
            Year,
            CountQuestions: count_questionaries,
            CountYes: count_yes,
            CountNull: count_null
          }
        })
      } else {

        yield call<any>(getDefaultSaga, {
          listName: VPOStatusQuestionnaireListName,
          filters: {
            ID: isStatusID
          },
        });

        yield call<any>(updateDefaultSaga, {
          listName: VPOStatusQuestionnaireListName,          
          body: {
            Status: currentStatusQuestionary && currentStatusQuestionary == 3 && 1 || currentStatusQuestionary,
            ID: isStatusID,
            CountYes: count_yes,
            CountNull: count_null,
            CountQuestions: count_questionaries,
          }
        })

      }



      // Запись статистики да/нет для отделов

      let reportRegionID = false;
      let count_questionaries_subdivision = 0;
      let count_yes_subdivision = 0;
      let count_null_subdivision = 0;
      let count_no_subdivision = 0;

      const response_report_region: unknown = yield call<any>(getDefaultSaga, {
        listName: 'ReportRegion',
        filtersType: 'and',
        filters: {
          ColumnID: '' + ColumnID,
          GroupID: '' + GroupID,
          FactoryID: '' + FactoryID,
          SubdivisionID: '' + SubdivisionID,
          Month: '' + Month,
          Year: '' + Year
        },
      });

      if(
        response_report_region &&
        response_report_region.items &&
        response_report_region.items.length > 0
      ){
        
        reportRegionID = response_report_region.items[0].ID;

      }

      let response_conditions_subdivision: unknown = yield call<any>(getDefaultSaga, {
        listName: VPORequirementsConditionsListName,
        filters: {
          GroupRequirementFileRef: '*' + ColumnID + '_.000/' + GroupID + '_.000',
          Month: '' + Month,
          Year: '' + Year,
          FactoryID: '' + FactoryID,
          Subdivision: SubdivisionID,
        },
      });

      console.log('response_conditions_subdivision', response_conditions_subdivision);

      if(
        response_conditions_subdivision &&
        response_conditions_subdivision.items &&
        response_conditions_subdivision.items.length > 0
      ){
        response_conditions_subdivision.items.map((item: any) => {
          if(item.Condition.get_lookupId() === 1){
            count_yes_subdivision = count_yes_subdivision + 1;
          }
          if(item.Condition.get_lookupId() === 2){
            count_no_subdivision = count_no_subdivision + 1;
          }
          if(item.Condition.get_lookupId() === 3){
            count_null_subdivision = count_null_subdivision + 1;
          }
        })
      }

      if(
        response_requirements &&
        response_requirements.items &&
        response_requirements.items.length > 0
      ){

        let count_requirements = response_requirements.items.filter(item => {

          let active_group = true;

          if(
            response_group_requirements &&
            response_group_requirements.items &&
            response_group_requirements.items.length > 0
          ){
            let filter_group = response_group_requirements.items.filter(group => item.FileRef.indexOf('/'+group.ID+'/') >= 0);

            if(
              filter_group &&
              filter_group.length > 0
            ){
              if(
                (
                  filter_group[0].FinishDate && 
                  filter_group[0].FinishDate !== '' && 
                  moment(filter_group[0].FinishDate) < moment() 
                ) || ( 
                  filter_group[0].StartDate1 && 
                  filter_group[0].StartDate1 !== '' && 
                  moment(filter_group[0].StartDate1) > moment() 
                ) 
              ){
                active_group = false;
              }
            }
          }

          return ( active_group && item.FinishDate && item.FinishDate !== '' && moment(item.FinishDate) > moment() ) ||
            ( active_group && item.StartDate1 && item.StartDate1 !== '' && moment(item.StartDate1) < moment() ) 
        });

        count_questionaries_subdivision = count_requirements.length;

        let count_no_default_subdivision = count_questionaries_subdivision - count_no_subdivision - count_yes_subdivision - count_null_subdivision;

        count_no_subdivision = count_no_subdivision + count_no_default_subdivision;
        
      }

      if(
        response_conditions_subdivision &&
        response_conditions_subdivision.items &&
        response_conditions_subdivision.items.length > 0
      ){


        // count_no_subdivision = count_no_subdivision + (count_questionaries_subdivision - response_conditions_subdivision.items.length);

        // count_null_subdivision = count_questionaries_subdivision - count_yes_subdivision - count_no_subdivision + count_null_subdivision;

      }

      // let response_requirements_subdivision: unknown = yield call<any>(getDefaultSaga, {
      //   listName: 'VPOColumns',
      //   recursiveAll: true,
      //   contentType: 'Requirement',
      //   filtersType: 'and',
      //   filters: {
      //     ContentTypeId: '^' + ContentTypeIdRequirement,
      //     FileRef: '*' + ColumnID + '_.000/' + GroupID + '_.000',
      //   }
      // })
      
      // if(
      //   response_requirements_subdivision &&
      //   response_requirements_subdivision.items &&
      //   response_requirements_subdivision.items.length > 0
      // ){

      //   let count_requirements = response_requirements_subdivision.items.filter(item => {
      //     return ( item.FinishDate && item.FinishDate !== '' && moment(item.FinishDate) > moment() ) ||
      //       ( item.StartDate1 && item.StartDate1 !== '' && moment(item.StartDate1) < moment() ) 
      //   });
        
      //   count_questionaries_subdivision = count_requirements.length;
      // }

      if(!reportRegionID){

        yield call<any>(addDefaultSaga, {
          listName: 'ReportRegion',
          body: {
            Title,
            ColumnID,
            ColumnTitle,
            GroupID,
            GroupTitle,
            FactoryID,
            FactoryTitle,
            Month,
            Year,
            SubdivisionID,
            SubdivisionTitle,
            CountQuestions: count_questionaries_subdivision,
            CountYes: count_yes_subdivision,
            CountNull: count_null_subdivision
          }
        })
      } else {

        yield call<any>(getDefaultSaga, {
          listName: 'ReportRegion',
          filters: {
            ID: reportRegionID
          },
        });

        yield call<any>(updateDefaultSaga, {
          listName: 'ReportRegion',
          body: {
            ID: reportRegionID,
            CountQuestions: count_questionaries_subdivision,
            CountYes: count_yes_subdivision,
            CountNull: count_null_subdivision
          }
        })

      }      
        
      yield call<any>(getSaga, {
        payload: {
          listName: VPORequirementsConditionsListName,
          contentType: VPORequirementsConditionsListName,
          filters: {
            GroupRequirementFileRef: '*' + ColumnID + '_.000/' + GroupID + '_.000',
            Month: '' + Month,
            Year: '' + Year,
            FactoryID: ''+FactoryID,
          },
        }
      })

      yield put(setStatusQuestionarySuccess())

    }
  } catch (error) {
    console.log(error);
  }
}
